module.exports = __webpack_public_path__ + "static/img/hengban.a4c56fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/tijianbaogao/hengban.jpg
// module id = jJSq
// module chunks = 9